import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ProfileCard from "@/components/ProfileCard";
import { useAccount } from "@/lib/account";

export default function Shortlist() {
  const { authed, account } = useAccount();
  const [items, setItems] = useState(null);
  const ids = (account?.shortlist || []).join(",");
  useEffect(() => { authed("get", "/shortlist").then(setItems).catch(() => setItems([])); }, [authed, ids]);
  return (
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14" data-testid="shortlist-page">
      <p className="text-xs uppercase tracking-[0.25em] text-amber-400 font-semibold">Saved</p>
      <h1 className="font-display text-4xl sm:text-5xl font-semibold mt-3">Your shortlist</h1>
      {items && items.length === 0 && <p className="text-slate-400 py-16" data-testid="shortlist-empty">Tap the heart on any profile to save it here. <Link to="/browse" className="text-amber-300 underline">Browse profiles</Link></p>}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-10">
        {(items || []).map((p, i) => <ProfileCard key={p.id} p={p} index={i} />)}
      </div>
    </div>
  );
}
